import React, { useCallback, useState } from 'react';
import { func, string } from 'prop-types';
import carPlateMask from '../../utils/carPlateMask';
import Text from '../../atoms/Text';
import { Form, Row, LicensePlateInput, LicensePlateButton, LicensePlateLink } from './cardan-form-license-plate.styles';

function CardanFormLicensePlate({
  onSubmit,
  onRedirect,
  submitButtonLabel,
  redirectButtonLabel,
  inputLabel,
  inputValue = '',
  errorMsg
}) {
  const [licensePlateNumber, setLicensePlateNumber] = useState(carPlateMask(inputValue));
  const [displayError, setDisplayError] = useState(false);

  const handleInputChange = e => {
    setLicensePlateNumber(carPlateMask(e.target.value));
    setDisplayError(false);
  };

  const handleSubmit = useCallback(e => {
    e.preventDefault();
    setDisplayError(true);
    onSubmit({
      licensePlateNumber
    });
  }, [licensePlateNumber, onSubmit]);
  const handleRedirect = useCallback(e => {
    e.preventDefault();
    onRedirect();
  }, [onRedirect]);
  return /*#__PURE__*/React.createElement(Form, {
    as: "form",
    "data-testid": "cardan-form"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: 1
  }, "Digite a placa do ve\xEDculo")), /*#__PURE__*/React.createElement(Row, {
    style: {
      marginBottom: '13px'
    }
  }, /*#__PURE__*/React.createElement(LicensePlateInput, {
    placeholder: inputLabel,
    onChange: handleInputChange,
    value: licensePlateNumber,
    "data-testid": "cardan-number-license-plate"
  }), /*#__PURE__*/React.createElement(LicensePlateButton, {
    disabled: licensePlateNumber.length !== 8,
    onClick: handleSubmit,
    uppercase: false,
    "data-testid": "cardan-form-submit-button"
  }, submitButtonLabel), onRedirect && /*#__PURE__*/React.createElement(LicensePlateLink, {
    onClick: handleRedirect,
    uppercase: false,
    size: "small",
    variation: "outline",
    "data-testid": "cardan-form-redirect-button"
  }, redirectButtonLabel)), /*#__PURE__*/React.createElement(Row, {
    style: {
      marginBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 1,
    color: "red"
  }, displayError && errorMsg)));
}

CardanFormLicensePlate.defaultProps = {
  submitButtonLabel: 'Buscar veículo',
  redirectButtonLabel: 'Buscar sem placa',
  inputLabel: 'Número da Placa'
};
process.env.NODE_ENV !== "production" ? CardanFormLicensePlate.propTypes = {
  onSubmit: func,
  onRedirect: func,
  submitButtonLabel: string,
  redirectButtonLabel: string,
  inputLabel: string,
  inputValue: string,
  errorMsg: string
} : void 0;
export default CardanFormLicensePlate;